export default {"src":"/_next/static/media/approval.6cb70d54.svg","height":160,"width":160};